import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {BaseModalComponent} from "app/shared/base-modal/base-modal.component";

@Component({
  selector: 'app-delete-size-scale-dialog',
  templateUrl: './delete-size-scale-dialog.component.html',
  styleUrls: ['./delete-size-scale-dialog.component.scss']
})
export class DeleteSizeScaleDialogComponent extends BaseModalComponent implements OnInit {

  usingScalesInProducts: string[] = [];
  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DeleteSizeScaleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteSizeScaleDialogData
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    this.usingScalesInProducts = this.data.usingScalesInProducts;
  }

  delete() {
    this.exit(DELETE_SIZE_SCALE)
  }

  cancel() {
    this.exit(NO_DELETE)
  }

  isScaleUsingInProducts() {
    return this.usingScalesInProducts.length > 0;
  }
}

export interface DeleteSizeScaleDialogData {
  usingScalesInProducts: string[]
}

export const NO_DELETE = 'no_delete'
export const DELETE_SIZE_SCALE = 'delete_size_scale'
